import React, { useState, useCallback } from 'react'
import {useHistory, useParams} from 'react-router-dom';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { addStore } from 'client/shared/react-util';
import { FieldFactory, EditImage, Editor } from 'client/shared/components';
import config from 'client/shared/config';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css';
import ReactModal from 'react-modal';
import { toast } from 'react-toastify';

import moment from 'moment';
import { NavLink } from 'react-router-dom';

import { SongTab } from './song-tab';
import artistStore from '../../common/stores/artist-store';
import ConfirmButton from 'common/components/confirm-button';
import MoodsGenreForm from './moods-genre';

// import ReactDataGrid from '@inovua/reactdatagrid-community'
// import '@inovua/reactdatagrid-community/index.css'

// import CheckBox from '@inovua/reactdatagrid-community/packages/CheckBox'

// import {gridStyle, filterValue, columns, defaultSortInfo} from './artist-grid-data';

const DFLT_MODAL_STYLE = {
	base: 'modal member-sign-up',
	afterOpen: 'modal-after-open',
	beforeClose: 'modal-before-close'
};

const DFLT_OVERLAY_STYLE = {
	base: 'modal-overlay',
	afterOpen: 'modal-overlay-after-open',
	beforeClose: 'modal-overlay-before-close'
};

const addFeatured = (artistStore, artist) => {
    artistStore.addFeaturedArtist(artist);
}

const ModalContent = ({artist, artistStore, formStore, savingMessage, handleCloseModal}) => {
    const FieldWithStore = addStore(FieldFactory, { formStore });

    console.log('[renderModalContent]', artistStore.isLoading);
    if (artistStore.isLoading) {

        return (
            <div className="loading-spinner large text-center" style={{
                height: '65vh'
            }}>{ savingMessage }</div>
        );
    }

    return (
        <div className="modal-content" data-ta="addBandModal" style={{backgroundColor: 'black', color: 'white !important'}}>
            <h4>Featured Artist Bio</h4>
            <FieldWithStore
                item={ artist }
                fieldKey="artist.featuredBio"
                store={artistStore}
                onChange={ artist.save }
                styles={{width: '30vw', height: '20vh'}}
            />
            <div className="modal-button-group">
                <button
                    data-ta="closeFeaturedArtistModalBtn"
                    className="button neo secondary"
                    onClick={ handleCloseModal }
                >
                    Close Modal
                </button>
                <button
                    data-ta="saveFeaturedArtistModalBtn"
                    className="button neo primary-color"
                    onClick={ () => {
                        addFeatured(artistStore, artist);
                        handleCloseModal();
                        artistStore.fetchItems();
                     } }
                >
                    Submit
                </button>
            </div>
        </div>
    );
}



const FeaturedArtistModal = (({artist, artistStore, formStore, modalOpen, onCloseModal}) => {
    const [savingMessage, setSavingMessage] = useState('');

    const modalContentLabel = '';
		return (
			<div className="artist-sign-up">
				<ReactModal
					appElement={ window.document.querySelector('#app') }
					isOpen={ modalOpen }
					shouldCloseOnOverlayClick={ false }
					contentLabel={ modalContentLabel }
					className={ DFLT_MODAL_STYLE }
					overlayClassName={ DFLT_OVERLAY_STYLE }
				>
					<h4 className="padding-left-2 padding-top-1">{ modalContentLabel }</h4>
					<ModalContent 
                        artist={artist} 
                        artistStore={artistStore} 
                        formStore={formStore} 
                        savingMessage={savingMessage}
                        handleCloseModal={onCloseModal}/>
				</ReactModal>
			</div>
		);
})

const ArtistNavTabs = observer(({artist, user, formStore, songsStore, playlistStore}) => {
    const [tabIndex, setTabIndex] = useState(0);
    const FieldWithStore = addStore(FieldFactory, { formStore });
    const styles = {
        backgroundImage: `url(${config.paths.profileImgBasePath}/${artist.user.profileImage})`,
        width: '13rem',
        height: '13rem',
        backgroundSize: '100% 16rem',
        backgroundPosition: `center`,
    };

    const fwStyles = {
        backgroundImage: `url(${config.paths.bannerImgBasePath}/${artist.bannerImage})`,
        height: `13rem`,
        width: `30rem`,
        backgroundSize: `contain`,
        backgroundRepeat: `no-repeat`,
        backgroundPosition: `center`,
    };

    return (
            <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                <TabList>
                    <Tab>Account Info</Tab>
                    <Tab>Songs</Tab>
                    <Tab>Scoring</Tab>
                    <Tab>Moods & Genre</Tab>
                </TabList>
                <TabPanel>
                    <h3 className="subheader">Account Info</h3>
                    <div className="grid-x" style={{alignItems:'center'}}>
                        <div className="margin-right-3">
                            <h6>Profile Image</h6>
                            <div style={styles}/>
                        </div>
                        <div className="margin-right-3">
                            <h6>Banner Image</h6>
                            <div style={fwStyles}/>
                        </div>
                        <div>
                            <h6>Bio</h6>
                            <div className="margin-bottom-1">
                                <Editor
                                    onChange={ artist.save }
                                    content={ artist.bio }
                                />
                                {/* <FieldWithStore
                                    item={ artist }
                                    fieldKey="artist.bio"
                                    store={artistStore}
                                    onChange={ artist.save }
                                    styles={{width: '30vw', height: '20vh'}}
                                /> */}
                            </div>
                        </div>
				    </div>
                    <div className="grid-x margin-top-1">
                        <div className="small-12 large-4 cell">
							<div className="margin-bottom-1">
                                <FieldWithStore
                                    item={ artist }
                                    fieldKey="artist.name"
                                    onChange={ artist.save }
                                />
                            </div>
							<div className="margin-bottom-1">
                                <FieldWithStore
                                    item={ user }
                                    fieldKey="user.firstName"
                                    onChange={ artist.save }
                                />
                            </div>
							<div className="margin-bottom-1">
                                <FieldWithStore
                                    item={ user }
                                    fieldKey="user.lastName"
                                    onChange={ artist.save }
                                />
                            </div>
                        </div>
                        <div className="small-12 large-4 cell">
                            <div className="margin-bottom-1">
                                <FieldWithStore
                                    item={ user }
                                    defaultValue={user.email}
                                    fieldKey="user.email"
                                />
                            </div>
							<div className="margin-bottom-1">
                                <FieldWithStore
                                    item={ artist }
                                    fieldKey="artist.paymentServiceID"
                                />
                            </div>
							<div className="margin-bottom-1">
                                <FieldWithStore
                                    item={ user }
                                    fieldKey="user.phoneNumber"
                                />
                            </div>
                        </div>
                        <div className="small-12 large-4 cell">
                            <div className="margin-bottom-1">
                                <FieldWithStore
                                    item={ user }
                                    fieldKey="user.location"
									defaultValue={user.location}
                                />
                            </div>
							<div className="margin-bottom-1">
                                <FieldWithStore
                                    item={ user }
                                    fieldKey="user.dob"
                                />
                            </div>
							<div className="margin-bottom-1">
                                <FieldWithStore
                                    item={ artist }
                                    fieldKey="artist.isExclusive"
                                />
                            </div>
                        </div>
                    </div>
                </TabPanel>
                
                <TabPanel>
                    <h3 className="subheader">Songs</h3>
                    {/* <p><i>Double-Click a row to edit it.</i></p> */}
                    <SongTab artist={artist} songsStore={songsStore} playlistStore={playlistStore}/>
                </TabPanel>

                <TabPanel>
                    <h3 className="subheader">Scoring</h3>
                </TabPanel>
                <TabPanel>
                    <h3 className="subheader">Moods & Genre</h3>
                    <MoodsGenreForm artist={artist} formStore={formStore}/>
                </TabPanel>
            </Tabs>
    )
})
const ArtistForm = observer(({artistStore, userStore, formStore, songsStore, playlistStore}) => {
    const { id } = useParams();
    const [modalOpen, setModalOpen] = useState(false);
    const history = useHistory();

    let artist = artistStore.getArtistByID(id);
    let user = userStore.getItemByID(artist.userID);
    if(user === undefined) { user = artist.user; }
    console.log(artist)
    console.log(user)
    return (
        <div>
            <button className="margin-top-1 margin-bottom-0 button neo super-small" onClick={() => history.push('/manage-artists')}>Back</button>
            <div className="grid-x" style={{alignItems: 'center'}}>
                <div>
                    <h1>{artist.name}</h1>
                </div>
                <div className="padding-top-1 margin-left-3 grid-x">
                    <button onClick={async () => {
                        try {
                            await artistStore.saveArtist(artist);
                            toast.success(`${artist.name} was saved successfully.`);
                        } catch (err) {
                            toast.error(`An error occured while saving ${artist.name}.`);
                            console.error('[ERROR SAVING ARTIST]', err);
                        }
                    }} className="button neo margin-right-3">Save</button>
                    {!artist.isFeatured && (
                        <button onClick={() => {setModalOpen(true)}} className="button neo margin-right-3">Set as Featured Artist</button>
                    )}
                    {artist.isFeatured && (
                        <button onClick={() => {setModalOpen(true)}} className="button neo margin-right-3">Edit Featured Artist</button>
                    )}
                    <ConfirmButton
                        warningText={ `Really delete ${artist.name}?` }
                        onConfirmClick={ 
                            async () => {
                                try {
                                    await artistStore.deleteItem(artist);
                                    toast.success(`${artist.name} was deleted successfully.`);
                                    history.push('/manage-artists')
                                } catch (err) {
                                    toast.error(`An error occured while deleting ${artist.name}.`);
                                    console.error('[ERROR DELETING ARTIST]', err);
                                }
                            }
                        }
                    >
                    </ConfirmButton>
                </div>
            </div>
            <ArtistNavTabs artist={artist} user={user} formStore={formStore} songsStore={songsStore} playlistStore={playlistStore}/>
            <FeaturedArtistModal
                modalOpen={modalOpen}
                onCloseModal={() => {setModalOpen(false)}}
                artist={artist}
                artistStore={artistStore}
                formStore={formStore}
            >
            </FeaturedArtistModal>
        </div>
    )
})


const injectWithStores = inject('artistStore', 'userStore', 'formStore', 'songsStore', 'playlistStore');

export default injectWithStores(
    ({artistStore, userStore, formStore, songsStore, playlistStore}) => {
        return (
            <ArtistForm artistStore={artistStore} userStore={userStore} formStore={formStore} songsStore={songsStore} playlistStore={playlistStore}/>
        )
    })